import { parseSearchAsStrings, queryToStrings, stringifySearchFromStrings } from './search'
import type { NavigationTarget } from './types'

export interface ResolvedTarget {
  to: string
  search: Record<string, string | string[]>
  hash?: string
}

/** A Next href (string with optional ?query#hash, or {pathname, query}) → TanStack navigate parts. */
export function resolveTarget(target: NavigationTarget, origin = 'http://localhost'): ResolvedTarget {
  if (typeof target === 'string') {
    const url = new URL(target, origin)
    return {
      to: url.pathname,
      search: parseSearchAsStrings(url.search),
      hash: url.hash ? url.hash.slice(1) : undefined,
    }
  }
  return {
    to: target.pathname,
    search: queryToStrings(target.query),
    hash: undefined,
  }
}

export function targetToHref(target: NavigationTarget): string {
  if (typeof target === 'string') return target
  return `${target.pathname}${stringifySearchFromStrings(queryToStrings(target.query))}`
}
